import React, { useEffect, useState } from 'react';
import PatientStatistics from '../../components/private/statistics/PatientStatistics';
import VisitsStatistics from '../../components/private/statistics/VisitsStatistics';
import PaymentStatistics from '../../components/private/statistics/PaymentStatistics';
import { useSelector } from 'react-redux';


import { motion, AnimatePresence } from 'framer-motion';


import { 
  FaUsers, 
  FaCalendarCheck, 
  FaCreditCard,
  FaChevronRight,
  FaBars,
  FaTimes,
  FaChevronLeft
} from 'react-icons/fa';
import Breadcrumbs from '../../components/private/Breadcrumbs';
import { arClass } from '../../utils/useArClass';






const Navigation = ({ 
  onNavigate, 
  currentView,
  defaultLanguage = 'en',
  navigationItems = [
    { 
      label: defaultLanguage === 'ar' ? 'إحصائيات المرضى' : defaultLanguage === 'fr' ? 'Statistiques des patients' : 'Patients Statistics', 
      view: 'patients',
      icon: <FaUsers className="text-lg" />
    },
    { 
      label: defaultLanguage === 'ar' ? 'إحصائيات الزيارات' : defaultLanguage === 'fr' ? 'Statistiques des visites' : 'Visits Statistics', 
      view: 'visits',
      icon: <FaCalendarCheck className="text-lg" />
    },
    { 
      label: defaultLanguage === 'ar' ? 'إحصائيات المدفوعات' : defaultLanguage === 'fr' ? 'Statistiques des paiements' : 'Payments Statistics', 
      view: 'payments',
      icon: <FaCreditCard className="text-lg" />
    },
  ]
}) => {
  const darkMode = useSelector((state) => state.settings.darkMode);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check screen size for responsiveness
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setIsMobileMenuOpen(false);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        staggerChildren: 0.1
      }
    }
  };

  const mobileContainerVariants = {
    hidden: { opacity: 0, height: 0 },
    visible: {
      opacity: 1,
      height: 'auto',
      transition: {
        duration: 0.4,
        staggerChildren: 0.1
      }
    },
    exit: {
      opacity: 0,
      height: 0,
      transition: {
        duration: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 100
      }
    },
    hover: {
      scale: 1.05,
      transition: {
        duration: 0.2
      }
    },
    tap: {
      scale: 0.95
    }
  };

  const mobileItemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        stiffness: 100
      }
    }
  };


  const handleNavigation = (view) => {
    onNavigate(view);
    if (isMobile) {
      setIsMobileMenuOpen(false);
    }
  };

  // Desktop Navigation
  const renderDesktopNav = () => (
    <>
      <motion.div 
        className={arClass(`absolute inset-0 rounded-2xl opacity-20 ${
          darkMode 
          ? 'bg-gradient-to-r from-green-900 to-blue-900' 
          : 'bg-gradient-to-r from-green-50 to-blue-50'
        }`)}
        animate={{
          background: [
            'linear-gradient(45deg, rgba(34, 197, 94, 0.05) 0%, rgba(59, 130, 246, 0.05) 100%)',
            'linear-gradient(45deg, rgba(59, 130, 246, 0.05) 0%, rgba(168, 85, 247, 0.05) 100%)',
            'linear-gradient(45deg, rgba(168, 85, 247, 0.05) 0%, rgba(34, 197, 94, 0.05) 100%)'
          ]
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      />
      
      <ul className={arClass("relative flex flex-wrap items-center justify-center gap-1 md:gap-2")}>
        {navigationItems.map((item, index) => {
          const isActive = currentView === item.view;
          
          return (
            <motion.li 
              key={item.view}
              variants={itemVariants}
              whileHover="hover"
              whileTap="tap"
              className="relative"
            >
              <button
                onClick={() => handleNavigation(item.view)}
                className={arClass(`
                  relative flex flex-col sm:flex-row items-center gap-2 
                  px-3 sm:px-4 md:px-6 py-2 sm:py-3 md:py-4 rounded-lg md:rounded-xl 
                  font-medium transition-all duration-300 w-full sm:w-auto max-sm:text-xs
                  ${darkMode 
                    ? isActive 
                      ? 'text-white' 
                      : 'text-gray-300 hover:text-white'
                    : isActive 
                      ? 'text-gray-900' 
                      : 'text-gray-600 hover:text-gray-900'
                  }
                `)}
              >
                {/* Icon with animation */}
                <motion.div
                  className={arClass("text-base sm:text-lg")}
                  animate={{
                    rotate: isActive ? [0, 10, -10, 0] : 0
                  }}
                  transition={{
                    duration: 0.5,
                    times: [0, 0.2, 0.8, 1]
                  }}
                >
                  {item.icon}
                </motion.div>
                
                <span className="text-xs sm:text-sm md:text-base whitespace-nowrap">
                  {isMobile ? item.label.split(' ')[0] : item.label}
                </span>
                
             
                
                {/* Active background glow */}
                {isActive && (
                  <motion.div
                    className={arClass(`absolute inset-0 rounded-lg md:rounded-xl ${
                      darkMode 
                      ? 'bg-gradient-to-r from-green-900/20 to-blue-900/20 border border-green-700/30' 
                      : 'bg-gradient-to-r from-green-50/20 to-blue-50/20 border border-green-200'
                    }`)}
                    layoutId="activeBackground"
                    transition={{
                      type: "spring",
                      stiffness: 300,
                      damping: 30
                    }}
                  />
                )}
                
                {/* Hover effect */}
                {!isActive && (
                  <motion.div
                    className={arClass(`absolute inset-0 rounded-lg md:rounded-xl ${
                      darkMode 
                      ? 'hover:bg-gray-700/30' 
                      : 'hover:bg-gray-100/50'
                    }`)}
                    initial={{ opacity: 0 }}
                    whileHover={{ opacity: 1 }}
                    transition={{ duration: 0.2 }}
                  />
                )}
              </button>
              
              {/* Separator - Hidden on mobile, visible on tablet+ */}
              {!isMobile && item.view !== navigationItems[navigationItems.length - 1].view && (
                <motion.div
                  className={arClass(`absolute right-0 top-1/2 -translate-y-1/2 hidden md:block`)}
                  animate={{
                    opacity: [0.3, 0.7, 0.3]
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    repeatType: "reverse"
                  }}
                >
                  {
                    defaultLanguage === 'ar' ? (
                      <FaChevronLeft className={arClass(`text-sm md:text-base ${
                        darkMode ? 'text-gray-500' : 'text-gray-400'
                      }`)} />
                    ) : (
                      <FaChevronRight className={arClass(`text-sm md:text-base ${
                        darkMode ? 'text-gray-500' : 'text-gray-400'
                      }`)} />
                    )
                  }
                </motion.div>
              )}
            </motion.li>
          );
        })}
      </ul>
    </>
  );

  // Mobile Navigation
  const renderMobileNav = () => (
    <>
      {/* Mobile Header */}
      <div className={arClass(`flex items-center justify-between`)}>
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={arClass(`flex items-center gap-2 px-4 py-3 rounded-lg font-medium max-sm:text-xs ${
            darkMode 
            ? 'bg-gray-700 text-white' 
            : 'bg-gray-100 text-gray-700'
          }`)}
        >
          {isMobileMenuOpen ? (
            <FaTimes className="text-lg" />
          ) : (
            <FaBars className="text-lg" />
          )}
          <span className="text-sm max-sm:text-xs">
            {navigationItems.find(item => item.view === currentView)?.label || 'Menu'}
          </span>
        </button>
        
        {/* Current View Indicator */}
        <div className={arClass(`px-3 py-2 rounded-lg text-sm font-medium max-sm:text-xs ${
          darkMode 
          ? 'bg-green-900/30 text-green-300' 
          : 'bg-green-100 text-green-700'
        }`)}>
          {currentView.charAt(0).toUpperCase() + currentView.slice(1)}
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            variants={mobileContainerVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className={arClass(`mt-3 overflow-hidden rounded-xl ${
              darkMode 
              ? 'bg-gray-800/90 border border-gray-700' 
              : 'bg-white/90 border border-gray-200'
            }`)}
          >
            <ul className={arClass("p-2")}>
              {navigationItems.map((item) => {
                const isActive = currentView === item.view;
                
                return (
                  <motion.li
                    key={item.view}
                    variants={mobileItemVariants}
                    className="mb-1 last:mb-0"
                  >
                    <button
                      onClick={() => handleNavigation(item.view)}
                      className={arClass(`
                        relative flex    gap-3 w-full px-4 py-3 
                        rounded-lg text-left transition-all duration-200 max-sm:text-xs
                        ${darkMode 
                          ? isActive 
                            ? 'bg-green-900/40 text-white' 
                            : 'text-gray-300 hover:bg-gray-700/50'
                          : isActive 
                            ? 'bg-green-100 text-gray-900' 
                            : 'text-gray-600 hover:bg-gray-100'
                        }
                      `)}
                    >
                      <motion.div
                        animate={{
                          rotate: isActive ? [0, 10, -10, 0] : 0
                        }}
                        transition={{
                          duration: 0.5,
                          times: [0, 0.2, 0.8, 1]
                        }}
                      >
                        {item.icon}
                      </motion.div>
                      
                      <div className={arClass("flex flex-col items-start ")}>
                        <div className="font-medium text-sm max-sm:text-xs">
                          {item.label}
                        </div>
                        {isActive && (
                          <div className={`text-xs mt-1 max-sm:text-xsm ${
                            darkMode ? 'text-green-300' : 'text-green-600'
                          }`}>
                            {
                              defaultLanguage === 'ar' ? 'المعرض حاليًا' 
                              : defaultLanguage === 'fr' ? 'Actuellement en cours' 
                              : 'Currently viewing'
                            }
                          </div>
                        )}
                      </div>
                      
                      {isActive && (
                        <motion.div
                          className={arClass(`w-2 h-2 rounded-full ${
                            darkMode ? 'bg-green-400' : 'bg-green-500'
                          }`)}
                          animate={{ scale: [1, 1.5, 1] }}
                          transition={{ repeat: Infinity, duration: 2 }}
                        />
                      )}
                    </button>
                  </motion.li>
                );
              })}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );

  return (
    <motion.nav 
      initial="hidden"
      animate="visible"
      variants={containerVariants}
      className={arClass(`relative p-3 md:p-4 my-3 md:my-4 rounded-xl md:rounded-2xl 
        shadow-sm md:shadow-lg backdrop-blur-sm ${
        darkMode 
        ? 'bg-gray-800/80 border-gray-700' 
        : 'bg-white/80 border-gray-100'
      } border`)}
    >
      {isMobile ? renderMobileNav() : renderDesktopNav()}
      
      {/* Floating particles animation - Hidden on mobile */}
      {!isMobile && (
        <AnimatePresence>
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className={arClass(`absolute top-0 w-1 h-1 rounded-full hidden md:block ${
                darkMode ? 'bg-green-400/30' : 'bg-green-500/30'
              }`)}
              initial={{
                x: Math.random() * 300,
                y: -10,
                opacity: 0
              }}
              animate={{
                y: [null, 60],
                opacity: [0, 1, 0]
              }}
              transition={{
                duration: 3,
                delay: i * 0.5,
                repeat: Infinity,
                repeatDelay: 2
              }}
            />
          ))}
        </AnimatePresence>
      )}
    </motion.nav>
  );
};

const Statistics = () => {
    const defaultLanguage = useSelector((state) => state.settings.defaultLanguage);
    const darkMode = useSelector((state) => state.settings.darkMode);
    const [currentView, setCurrentView] = React.useState('patients');

    const handleNavigate = (view) => {
        setCurrentView(view);
    };

    const renderContent = () => {
        switch (currentView) {
            case 'patients':
                return <PatientStatistics />;
            case 'visits':
                return <VisitsStatistics />;
            case 'payments':
                return <PaymentStatistics />;
            default:
                return <PatientStatistics />;
        }
    };
    return (
        <div>
            <Breadcrumbs />
            <Navigation onNavigate={handleNavigate} currentView={currentView} defaultLanguage={defaultLanguage} darkMode={darkMode} />
            <div>
                {renderContent()}
            </div>
        </div>
    );
}

export default Statistics;
